const SECONDS_PER_HOUR = 3600;
const SECONDS_PER_MINUTE = 60;

function pad(value: number) {
	return value.toString().padStart(2, "0");
}

export function secondsToDurationInput(seconds: number | undefined) {
	if (seconds === undefined) return "";

	const normalizedSeconds = Math.max(0, Math.round(seconds));
	const hours = Math.floor(normalizedSeconds / SECONDS_PER_HOUR);
	const minutes = Math.floor((normalizedSeconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE);
	const remainingSeconds = normalizedSeconds % SECONDS_PER_MINUTE;

	return `${pad(hours)}:${pad(minutes)}:${pad(remainingSeconds)}`;
}

export function durationInputToSeconds(duration: string) {
	const value = duration.trim();
	if (!value) return undefined;

	const parts = value.split(":").map((part) => Number(part));
	if (parts.some((part) => !Number.isFinite(part) || part < 0)) return undefined;

	if (parts.length === 1) return Math.round(parts[0]);
	if (parts.length === 2) return Math.round(parts[0] * SECONDS_PER_MINUTE + parts[1]);
	if (parts.length === 3) return Math.round(parts[0] * SECONDS_PER_HOUR + parts[1] * SECONDS_PER_MINUTE + parts[2]);

	return undefined;
}

export function formatSecondsAsDuration(seconds: number | undefined) {
	return secondsToDurationInput(seconds);
}
